import Block0301 from './Block0301';
import Block0302 from './Block0302';
import Block0303 from './Block0303';

const Section03 = (props) => {
    return (
        <>
            <Block0301 />
            <Block0302 />
            <Block0303 />
        </>
    );
};

export default Section03;
